import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-71e82bb3")

_pushScopeId("data-v-71e82bb3")
const _hoisted_1 = { class: "p-mx-4" }
const _hoisted_2 = {
  key: 0,
  class: "p-mx-4"
}
const _hoisted_3 = {
  id: "document-browser-detail",
  class: "p-d-flex p-flex-row kn-flex p-m-0"
}
const _hoisted_4 = {
  id: "detail-container",
  class: "p-d-flex p-flex-column"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Menu = _resolveComponent("Menu")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_DocumentBrowserTree = _resolveComponent("DocumentBrowserTree")
  const _component_DocumentBrowserDetail = _resolveComponent("DocumentBrowserDetail")
  const _component_DocumentBrowserHint = _resolveComponent("DocumentBrowserHint")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
      start: _withId(() => [
        _createVNode("i", {
          class: "fa fa-ellipsis-v p-mr-3",
          id: "sidebar-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebarView && _ctx.toggleSidebarView(...args)))
        }),
        _createVNode("span", null, _toDisplayString(_ctx.searchMode ? _ctx.$t('documentBrowser.documentsSearch') : _ctx.$t('documentBrowser.title')), 1),
        _withDirectives(_createVNode("span", _hoisted_1, [
          _createVNode("i", {
            class: "fa fa-arrow-left search-pointer p-mx-4",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.exitSearchMode && _ctx.exitSearchMode(...args)))
          }),
          _createVNode(_component_InputText, {
            id: "document-search",
            class: "kn-material-input p-inputtext-sm p-mx-2",
            ref: "searchBar",
            onKeyup: _withKeys(_ctx.loadDocuments, ["enter"]),
            modelValue: _ctx.searchWord,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchWord = $event)),
            placeholder: _ctx.$t('common.search'),
            autofocus: ""
          }, null, 8, ["onKeyup", "modelValue", "placeholder"]),
          _createVNode("i", {
            class: "fa fa-times search-pointer p-mx-4",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchWord = ''))
          }),
          _createVNode("i", {
            class: "pi pi-search search-pointer p-mx-4",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.loadDocuments && _ctx.loadDocuments(...args)))
          })
        ], 512), [
          [_vShow, _ctx.searchMode]
        ])
      ]),
      end: _withId(() => [
        (!_ctx.searchMode)
          ? (_openBlock(), _createBlock("span", _hoisted_2, [
              _createVNode("i", {
                class: "pi pi-search search-pointer",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openSearchBar()))
              })
            ]))
          : _createCommentVNode("", true),
        ((_ctx.isSuperAdmin || _ctx.canAddNewDocument) && _ctx.selectedFolder && _ctx.selectedFolder.parentId && _ctx.selectedFolder.codType !== 'USER_FUNCT')
          ? (_openBlock(), _createBlock(_component_KnFabButton, {
              key: 1,
              icon: "fas fa-plus",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggle($event))),
              "aria-haspopup": "true",
              "aria-controls": "overlay_menu"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Menu, {
          ref: "menu",
          model: _ctx.items,
          popup: true
        }, null, 8, ["model"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          class: "kn-progress-bar",
          mode: "indeterminate",
          "data-test": "progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      (_ctx.sidebarVisible && _ctx.windowWidth < 1024)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            id: "document-browser-sidebar-backdrop",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sidebarVisible = false))
          }))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode("div", {
        class: ["document-sidebar kn-flex", { 'sidebar-hidden': _ctx.isSidebarHidden, 'document-sidebar-absolute': _ctx.sidebarVisible && _ctx.windowWidth < 1024 }],
        style: {"width":"350px"}
      }, [
        _createVNode(_component_DocumentBrowserTree, {
          propFolders: _ctx.folders,
          selectedBreadcrumb: _ctx.selectedBreadcrumb,
          selectedFolderProp: _ctx.selectedFolder,
          onFolderSelected: _ctx.setSelectedFolder
        }, null, 8, ["propFolders", "selectedBreadcrumb", "selectedFolderProp", "onFolderSelected"])
      ], 2), [
        [_vShow, !_ctx.searchMode]
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.selectedFolder || _ctx.searchMode)
          ? (_openBlock(), _createBlock(_component_DocumentBrowserDetail, {
              key: 0,
              propDocuments: _ctx.searchMode ? _ctx.searchedDocuments : _ctx.documents,
              breadcrumbs: _ctx.breadcrumbs,
              searchMode: _ctx.searchMode,
              onBreadcrumbClicked: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setSelectedBreadcrumb($event))),
              onDocumentCloned: _ctx.loadDocuments,
              onDocumentStateChanged: _ctx.loadDocuments,
              onItemSelected: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('itemSelected', $event))),
              onShowDocumentDetails: _ctx.openDocumentDetails
            }, null, 8, ["propDocuments", "breadcrumbs", "searchMode", "onDocumentCloned", "onDocumentStateChanged", "onShowDocumentDetails"]))
          : (_openBlock(), _createBlock(_component_DocumentBrowserHint, {
              key: 1,
              "data-test": "document-browser-hint"
            }))
      ])
    ])
  ], 64))
})